// Module
var code = "<!-- ko foreach: _statuses --> <h1 data-bind=\"text: Environment\"></h1> <!-- ko foreach: Statuses --> <div> <!-- ko text: $data.Name --><!-- /ko -->: <!-- ko text: $data.Description || 'OK' --><!-- /ko --> </div> <!-- /ko --> <!-- /ko -->";
// Exports
export default code;